import { useMutation } from '@tanstack/react-query';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1';
import {
	BulkInviteAuthorisedSignatoryRes,
	BulkDownloadFileFilters,
} from '@dealstack/shared/lib/generated';

export interface BulkInviteAuthorisedSignatoryBody {
	allDocumentsSelected: boolean;
	selectedDocumentWorkflowInstanceIds?: string[];
	excludedDocumentWorkflowInstanceIds?: string[];
	filters?: BulkDownloadFileFilters;
	changes?: Array<{
		roleName: string;
		roleIds: string[];
		email: string;
		firstName: string;
		lastName: string;
	}>;
	cancellations?: Array<{
		roleName: string;
		roleIds: string[];
		email: string;
	}>;
}

export const useBulkInviteAuthorisedSignatory = ({
	dealId,
	programmeId,
	onSuccess,
	onSettled,
}: {
	dealId: string;
	programmeId: string;
	onSuccess?: (data: ApiV1.Response<BulkInviteAuthorisedSignatoryRes>) => void;
	onSettled?: () => void;
}) => {
	const tMipManage = useTranslationMipManage();
	return useMutation({
		mutationFn: async (body: BulkInviteAuthorisedSignatoryBody) => {
			const endpoint = formatUnicorn(
				API_PATHS.DEAL_DEALID_MIP_PROGRAMMEID_DOCUMENT_WORKFLOW_BULK_INVITE_AUTHORISED_SIGNATORY_POST,
				{ dealId, programmeId }
			);
			return await makeRequest<ApiV1.Response<BulkInviteAuthorisedSignatoryRes>>({
				endpoint,
				method: HTTP_METHOD.POST,
				body: JSON.stringify(body),
			});
		},
		onSuccess,
		onError: () =>
			showToastV2({
				state: 'error',
				title: tMipManage('documents_page.toast.invite_authorised_signatory.error'),
			}),
		onSettled,
	});
};
